// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-block {
  background-color: var(--white-color-lightest);
  border-radius: 8px;
  border: solid 1px var(--border-weak-color);
  border: none;
  padding: 16px;
  transition: box-shadow 0.3s ease;
}
.card-block.popup:hover {
  box-shadow: var(--omni-shadow-hidden);
}
.card-block.solid-card {
  box-shadow: var(--omni-shadow-hidden);
}
.card-block.base-card {
  padding: 40px 40px;
}
.card-block.info-card {
  background-color: var(--input-bg-color);
  border: none;
}
.card-block.border-card {
  background-color: transparent;
  border: solid 1px var(--border-color);
}`, "",{"version":3,"sources":["webpack://./src/_core/components/common/UI/Card.scss"],"names":[],"mappings":"AAAA;EACE,6CAAA;EACA,kBAAA;EACA,0CAAA;EACA,YAAA;EACA,aAAA;EACA,gCAAA;AACF;AACE;EACE,qCAAA;AACJ;AAEE;EACE,qCAAA;AAAJ;AAGE;EACE,kBAAA;AADJ;AAIE;EACE,uCAAA;EACA,YAAA;AAFJ;AAKE;EACE,6BAAA;EACA,qCAAA;AAHJ","sourcesContent":[".card-block {\r\n  background-color: var(--white-color-lightest);\r\n  border-radius: 8px;\r\n  border: solid 1px var(--border-weak-color);\r\n  border: none;\r\n  padding: 16px;\r\n  transition: box-shadow 0.3s ease;\r\n\r\n  &.popup:hover{\r\n    box-shadow: var(--omni-shadow-hidden);\r\n  }\r\n  \r\n  &.solid-card{\r\n    box-shadow: var(--omni-shadow-hidden);\r\n  }\r\n\r\n  &.base-card{\r\n    padding: 40px 40px;\r\n  }\r\n\r\n  &.info-card{\r\n    background-color: var(--input-bg-color);\r\n    border: none;\r\n  }\r\n\r\n  &.border-card{\r\n    background-color: transparent;\r\n    border: solid 1px var(--border-color);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
